import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { useIsFullMoonePersona } from "Hooks/useIsFullMoonePersona";
import { useLoggedInUser } from "Hooks/useLoggedInUser";

/**
 * The viewer's own side of name disclosure (App ADR-0011, product matrix 2026-10-21), read once
 * for every surface that tells the viewer "they will see your name": a private Full Moone persona
 * discloses their real name by messaging someone or by becoming mutual followers; a public one
 * already shows it to everyone, and a Lite one discloses nothing at all.
 *
 * `isFullMoone` is the active persona's tier by the API's rule (useIsFullMoonePersona, role-first);
 * `isPrivate` comes from user-info, the only client source of the visibility setting. Both are
 * false for an anonymous visitor and while user-info is still loading — a notice about disclosure
 * is only shown once it is known to be true.
 */
export const useViewerDisclosure = () => {
  const user = useLoggedInUser();
  const isFullMoone = useIsFullMoonePersona();
  const { data: userInfo } = useUserInfoQuery(!!user);

  const isPrivate = userInfo?.isProfilePublic === false;

  return {
    isFullMoone,
    isPrivate,
    /** Acting (messaging, following back) would reveal the viewer's real name to the other side. */
    disclosesName: isPrivate && isFullMoone,
  };
};
